import {ResponseStatus} from './response.status.model';

export class ResponseMessage {
  status!: ResponseStatus;

  message!: string;

  messages!: string[];
}
